import styled from '@emotion/styled';
import { Link } from 'react-scroll';

export interface PostTableOfContentsListItemProps {
  handleSetActiveItem: (item: string) => void;
  headingKey: string;
  headingId: string;
  headingString: string;
  isActive: boolean;
}

const PostTableOfContentsListItem = ({
  handleSetActiveItem,
  headingKey,
  headingId,
  headingString,
  isActive,
}: PostTableOfContentsListItemProps) => {
  return (
    <li key={`${headingKey}-${headingId}`}>
      <PostToClick
        to={headingId}
        href={`#${headingId}`}
        offset={-120}
        duration={350}
        delay={25}
        spyThrottle={1}
        spy
        smooth
        onSetActive={handleSetActiveItem}
        className={`${isActive ? 'active' : ''} blog-post-toc-item`}
      >
        {headingString}
      </PostToClick>
    </li>
  );
};

const PostToClick = styled(Link)`
  font-size: var(--font-size-base);
  text-decoration: none;
  color: var(--text-action);
  display: block;
  padding: 8px 12px;
  line-height: 24px;
  cursor: pointer;
  border-radius: var(--border-radius-tiny);
  :visited {
    color: inherit;
  }
  :hover {
    color: var(--text-action-dark);
    text-decoration: underline;
  }
  &.active {
    color: var(--text-action-dark);
    background: var(--surface-cool-strong);
  }
`;

export { PostTableOfContentsListItem };
